import { useMutation, useQueryClient } from 'react-query';

import { getForwardingEmailKey, useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  UseForwardingEmailListCreateParams,
  ForwardingEmailData,
} from './types';

export const useCreateForwardingEmail: MutationFunction<
  any,
  UseForwardingEmailListCreateParams
> = ({ query, requestOptions, queryOptions } = {}) => {
  const queryClient = useQueryClient();
  const mutationKey = getForwardingEmailKey();
  const request = useRequest(requestOptions);

  return useMutation(
    () =>
      request(`/suppliers/email_forwarding_settings`, {
        query,
        init: { method: 'POST' },
      }),
    {
      ...queryOptions,
      mutationKey,
      onSuccess: (...args) => {
        const data = args[0];
        const oldData =
          queryClient.getQueryData<ForwardingEmailData[]>(mutationKey);
        queryClient.setQueryData(
          mutationKey,
          oldData ? oldData.concat(data) : [data],
        );
        queryOptions?.onSuccess?.(...args);
      },
    },
  );
};
